export default __webpack_public_path__ + "static/team_member-4759f946290fb749128e85f2522792f0.png";